import { createFileRoute } from "@tanstack/react-router";
import { useParams } from "@/lib/navigation";
import { ProductDetail } from "@/components/ProductsPricing/Detail";

function RouteComponent() {
  const params = useParams();
  const id = params?.id as string;

  return <ProductDetail productId={id} />;
}

export const Route = createFileRoute("/_authenticated/products-pricing/$id/")({
  component: RouteComponent,
  staticData: { page: "finance" },
});
